var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { PresentationService } from "./services/presentation.service";
var AigoBot = /** @class */ (function (_super) {
    __extends(AigoBot, _super);
    function AigoBot(botId) {
        return _super.call(this, botId) || this;
    }
    AigoBot.initialize = function (botId) {
        if (!AigoBot.instance) {
            AigoBot.instance = new AigoBot(botId);
        }
        return AigoBot.instance;
    };
    return AigoBot;
}(PresentationService));
export { AigoBot };
